async function main() {
  const rootElem = document.getElementById('root');

  const checkIE = /* @cc_on!@ */false || !!document.documentMode;

  switch (checkIE) {
    default:
    case false:
      // Load react app view
      try {
        const { init } = await import('@/spa');

        // Initialize React app
        init(rootElem);
      } catch (e) {
        console.log('error import', e);
      }
      break;
    case true:
      try {
        const { init } = await import('@/ie.js');

        init(rootElem);
      } catch (e) {
        console.log('error import');
      }

      break;
  }
}

window.addEventListener('DOMContentLoaded', main);



// WEBPACK FOOTER //
// ./src/main.js